// v3.9.00: estado persistente de bootstrap por farmId no IndexedDB.
// Substitui o marcador booleano da v3.8.10 (farmBundleBootstrapMarkerKey).
import { DB } from "./deviceStorage";

const _bsKey = (farmId) => `fz:${String(farmId || "")}_bootstrap_state`;
const _legacyMarkerKey = (farmId) => `fz:${String(farmId || "")}:_farm_bundle_bootstrap_completed`;

const _VALID_STATUSES = new Set([
  "not_started", "snapshot_in_progress", "snapshot_completed",
  "post_delta_checking", "post_delta_failed", "ready", "aborted",
]);

const _emptyState = (farmId, appVersion = "") => ({
  status: "not_started",
  farmId: String(farmId || ""),
  appVersion: String(appVersion || ""),
  bootstrapId: "",
  startedAt: null,
  updatedAt: null,
  completedAt: null,
  watermarks: { revisions: {}, cursors: {} },
  completedCollections: [],
  pendingCollections: [],
  progress: 0,
  postDeltaChecked: false,
});

export async function getBootstrapState(farmId) {
  if (!farmId) return _emptyState(farmId);
  try {
    const raw = await DB.get(_bsKey(farmId));
    if (raw && typeof raw === "object" && _VALID_STATUSES.has(raw.status)) return raw;
    // Migração suave do marcador simples da v3.8.10: preserva dispositivos já hidratados.
    const legacy = await DB.get(_legacyMarkerKey(farmId));
    if (legacy?.completed) {
      return {
        ..._emptyState(farmId, legacy?.appVersion || ""),
        status: "ready",
        progress: 100,
        postDeltaChecked: true,
        completedAt: legacy?.completedAt || new Date().toISOString(),
        updatedAt: legacy?.completedAt || new Date().toISOString(),
      };
    }
    return _emptyState(farmId);
  } catch (_) { return _emptyState(farmId); }
}

export async function setBootstrapState(farmId, patch) {
  if (!farmId) return null;
  try {
    const current = await getBootstrapState(farmId);
    const next = { ...current, ...patch, farmId: String(farmId), updatedAt: new Date().toISOString() };
    await DB.set(_bsKey(farmId), next);
    return next;
  } catch (_) { return null; }
}

export async function clearBootstrapState(farmId) {
  if (!farmId) return;
  try { await DB.set(_bsKey(farmId), null); } catch (_) {}
}

export function isBootstrapReady(state) {
  return state?.status === "ready";
}

export function isBootstrapBlocking(state) {
  if (!state || state.status === "not_started") return false;
  return state.status !== "ready";
}

export function getBootstrapProgress(state) {
  if (!state) return 0;
  if (state.status === "ready") return 100;
  return Math.min(99, Math.max(0, Number(state.progress) || 0));
}
